var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('progress-bar',{attrs:{"items":_vm.counts,"mode":"multiple","value":30}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }